export default __webpack_public_path__ + "static/media/f_instagram.48bda0a6.svg";